import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { selectors } from '../../reducer';
import * as actions from '../../actions';
import * as Styled from './AvailableReceiptsBlock.styles';
import {
  deleteFromLocalStorage,
  setToLocalStorage,
} from '../../../../global/helpers';

const AvailableReceiptsBlock: React.FC<{ confirm?: () => void }> = ({
  confirm,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currentReceipt = useSelector(selectors.currentReceipt);
  const chosenReceipt = useSelector(selectors.chosenReceipt);

  useEffect(() => {
    !chosenReceipt && deleteFromLocalStorage('chosenReceipt');
  }, [currentReceipt]);

  if (!currentReceipt) return null;

  return (
    <Styled.AllReceiptsBlock>
      {currentReceipt.length > 0 ? (
        <>
          {currentReceipt.map((item) => (
            <div
              className="receipt-item"
              onClick={() => {
                setToLocalStorage('chosenReceipt', item);
                dispatch(actions.setChosenReceipt.request(item));
                confirm && confirm();
              }}
            >
              <h2 className="receipt-item-title">
                {t('LoyaltyPage.ACTIVE_RECEIPT')} №{item.doc_id}
              </h2>
              {item.items?.map((item, index) => (
                <div className="receipt-item-product">
                  {index + 1}. {item.name} x {item.quantity} шт.
                </div>
              ))}
            </div>
          ))}
        </>
      ) : (
        <p className="not-available-receipts">
          {t('LoyaltyPage.NOT_AVAILABLE_RECEIPTS')}
        </p>
      )}
    </Styled.AllReceiptsBlock>
  );
};

export default AvailableReceiptsBlock;
